<template>
  <div class="news-page">
    <section class="page-hero news-hero">
      <div class="container news-hero__shell">
        <span class="eyebrow">News</span>
        <p class="news-hero__date">Apr.2026</p>
        <h1 class="news-hero__title">When Japan Turns Pink – A Once-in-a-Lifetime Cherry Blossom Journey</h1>
      </div>
    </section>

    <section class="section-tight news-article">
      <div class="container news-article__shell">
        <div class="news-gallery card-panel">
          <img src="/images/news1.jpg" alt="Cherry blossom riverside scenery in Japan" class="news-gallery__image">
          <img src="/images/news2.jpg" alt="Cherry blossom travel view in Japan" class="news-gallery__image">
        </div>

        <article class="news-story card-panel">
          <p>Experience Japan at its most breathtaking moment—when it transforms into a dreamscape of soft pink petals and unforgettable beauty.</p>
          <p>Our exclusive cherry blossom tours are carefully designed to capture the very best of sakura season, combining iconic viewpoints and seamless travel experiences that go far beyond the ordinary.</p>
          <p>From the world-famous riverside tunnels of blooming cherry trees to serene temple gardens and elegant city parks, each itinerary is crafted to showcase the most stunning seasonal scenery. Whether it’s a peaceful morning stroll under falling petals or a golden-hour view along illuminated blossoms, every moment is designed to be picture-perfect.</p>
          <p>While the sakura season is now coming to an end and the blossoms in Tokyo are already starting to fall, this is the perfect time to begin planning ahead for next year.</p>
          <p>Don’t miss the opportunity to experience Japan at its most breathtaking moment. By securing your arrangements early, you can enjoy the very best viewing spots, carefully selected itineraries, and smooth, stress-free travel during the peak season.</p>
          <p>Let’s start planning now for next year’s cherry blossom season in Japan, and create an unforgettable journey filled with beauty, culture, and once-in-a-lifetime memories.</p>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'News'
};
</script>

<style scoped>
.news-hero__shell,
.news-gallery,
.news-story {
  padding: 34px;
}

.news-hero__shell {
  display: grid;
  gap: 12px;
  max-width: 960px;
}

.news-hero__date {
  margin: 0;
  color: var(--color-accent-deep);
  font-size: 13px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.news-hero__title {
  margin: 0;
  font-size: clamp(30px, 4vw, 48px);
  line-height: 1.25;
}

.news-article__shell {
  display: grid;
  gap: 24px;
}

.news-gallery {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.news-gallery__image {
  width: 100%;
  height: 320px;
  object-fit: cover;
  border-radius: 22px;
  display: block;
}

.news-story {
  display: grid;
  gap: 18px;
}

.news-story p {
  margin: 0;
  color: var(--color-muted);
  line-height: 1.95;
}

@media (max-width: 767px) {
  .news-hero__shell,
  .news-gallery,
  .news-story {
    padding: 22px;
  }

  .news-gallery {
    grid-template-columns: 1fr;
  }

  .news-gallery__image {
    height: 240px;
  }
}
</style>
